var map = {
	"./frontend/AndroidGuide.vue": 29596,
	"./frontend/Banking.vue": 26071,
	"./frontend/BetslipHistory.vue": 76667,
	"./frontend/BodyFB.vue": 11310,
	"./frontend/Commission.vue": 54832,
	"./frontend/ContactUs.vue": 24538,
	"./frontend/DataTable.vue": 36107,
	"./frontend/Deposit.vue": 95003,
	"./frontend/History.vue": 64629,
	"./frontend/Home.vue": 30505,
	"./frontend/IOSGuide.vue": 222,
	"./frontend/Iframe copy.vue": 34991,
	"./frontend/Iframe.vue": 41927,
	"./frontend/Index.vue": 61547,
	"./frontend/Live.vue": 31445,
	"./frontend/LiveScore.vue": 72184,
	"./frontend/MainMenu.vue": 33209,
	"./frontend/MatchResult.vue": 16948,
	"./frontend/MaungFB.vue": 79674,
	"./frontend/Promotion.vue": 75075,
	"./frontend/Setting.vue": 18286,
	"./frontend/VideoLink.vue": 66575,
	"./frontend/VipLevels.vue": 8374,
	"./frontend/Withdraw.vue": 98543,
	"./frontend/auth/Login.vue": 64783,
	"./frontend/auth/Register.vue": 75660,
	"./frontend/auth/Rule.vue": 24557,
	"./frontend/auth/Verify.vue": 92260,
	"./frontend/auth/VerifyNotAuth.vue": 72362,
	"./frontend/components/AccountSelect.vue": 5056,
	"./frontend/components/AppHeader.vue": 15754,
	"./frontend/components/DataTable.vue": 31546,
	"./frontend/components/FBPreviewVoucher.vue": 71814,
	"./frontend/components/FBVoucher.vue": 35578,
	"./frontend/components/FootballTeamCard.vue": 8956,
	"./frontend/components/GroupBox.vue": 48747,
	"./frontend/components/InputSelectDrawModal.vue": 90313,
	"./frontend/components/LuckyWheel.vue": 74090,
	"./frontend/components/NormalBox.vue": 63243,
	"./frontend/components/PreviewVoucher.vue": 96565,
	"./frontend/components/SideNav.vue": 30850,
	"./frontend/components/Table.vue": 50853,
	"./frontend/components/ThreedGroupBox.vue": 95959,
	"./frontend/components/TwoDSelect.vue": 89795,
	"./frontend/components/Voucher.vue": 20903,
	"./frontend/normal-user/2d/2d.vue": 40974,
	"./frontend/normal-user/2d/ClosedDays.vue": 18848,
	"./frontend/normal-user/2d/Home.vue": 63102,
	"./frontend/normal-user/2d/Winner.vue": 70630,
	"./frontend/normal-user/3d/3d.vue": 61583,
	"./frontend/normal-user/3d/Home.vue": 88676,
	"./frontend/normal-user/DreamBooks.vue": 46314,
	"./frontend/normal-user/Index.vue": 56012,
	"./frontend/normal-user/bugyee/Room.vue": 65589,
	"./frontend/normal-user/game/Arcade.vue": 29411,
	"./frontend/normal-user/game/Fishing.vue": 47440,
	"./frontend/normal-user/game/Game.vue": 45362,
	"./frontend/normal-user/game/Slot.vue": 57781,
	"./frontend/normal-user/shankomee/Room.vue": 78604
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5477;